<template>
  <div class="services-area-three ptb-100">
    <div class="container">
      <div
        class="section-title text-center m-auto"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">خدماتنا</span>
        <h2>كل ما تحتاجه لترفيه متكامل</h2>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(service, index) in services"
          :key="service.id"
          class="col-lg-4 col-sm-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="200 + index * 100"
        >
          <div class="position-relative z-1 shape-wrap">
            <div class="services-single-item-three hover-style1">
              <div class="hover-style2">
                <i :class="service.icon" class="icon"></i>
                <h3>
                  <RouterLink to="/services-details">
                    {{ service.title }}
                  </RouterLink>
                </h3>
                <p>{{ service.description }}</p>
                <RouterLink
                  to="/services-details"
                  class="read-more style-two text-grey-teal"
                >
                  المزيد <i class="ti ti-arrow-right"></i>
                </RouterLink>
              </div>
            </div>
            <img
              src="@/assets/images/services-shape-2.png"
              class="services-shape d-none d-xl-block"
              alt="services-shape"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "OurServices",
  setup() {
    const services = ref([
      {
        id: 1,
        title: "بث مباشر IPTV 4K",
        icon: "flaticon-global-network",
        description: "استمتع بأفضل تجربة بث مباشر بدقة 4K فائقة الجودة لجميع القنوات العالمية والأوروبية.",
      },
      {
        id: 2,
        title: "دعم الأجهزة الذكية",
        icon: "flaticon-box",
        description: "خدمتنا متوافقة تماماً مع جميع أنواع الشاشات الذكية (Smart TV) وأجهزة الأندرويد في منزلك.",
      },
      {
        id: 3,
        title: "مكتبة أفلام ومسلسلات",
        icon: "flaticon-global-network",
        description: "آلاف الأفلام والمسلسلات الحصرية المحدثة يومياً لتستمتع بها في أي وقت وفي أي مكان.",
      },
      {
        id: 4,
        title: "خوادم مستقرة في أوروبا",
        icon: "flaticon-global-network",
        description: "استقرار تام في البث مع سيرفراتنا المصممة خصيصاً لتعمل بكفاءة عالية داخل ألمانيا وأوروبا.",
      },
      {
        id: 5,
        title: "دعم فني 24/7",
        icon: "flaticon-phone-call-2",
        description: "فريق دعم فني محترف جاهز لمساعدتك في أي وقت، لضمان استمتاعك بالخدمة دون انقطاع.",
      },
      {
        id: 6,
        title: "اشتراكات مرنة",
        icon: "flaticon-smart-home",
        description: "باقات اشتراك متنوعة تناسب احتياجاتك بأسعار تنافسية وخيارات دفع آمنة وموثوقة.",
      },
    ]);

    return { services };
  },
});
</script>